import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ProjectPDFLink,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateThreePDFSectionWithSubsections } from "./common";
import { ResumePDFIcon } from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeProject, ResumeAward } from "lib/redux/types";

export const Award = ({
  heading,
  awards,
}: {
  heading: string;
  awards: ResumeAward[];
}) => {
  return (
    <TemplateThreePDFSectionWithSubsections heading={heading}>
      {awards.map(({ award, issuer, descriptions }, idx) => (
        <View
          key={idx}
          style={{ 
            ...styles.flexRow, 
            gap: "9pt",
            ...(idx !== 0 ? { marginTop: "9pt" } : {})
          }}
          wrap={false} 
        >
          <View style={{ width: "21%", marginTop: spacing["0.5"] }}></View>
          <View style={{ width: "79%", marginTop: spacing["0.5"] }}>
            <View
              style={{
                marginTop: spacing["0.5"],
              }}
            >
              <View
                style={{
                  ...styles.flexRow,
                  gap: spacing["2"],
                }}
              >
                <ResumePDFText bold={true}>{award}</ResumePDFText>
                <ResumePDFText>{issuer}</ResumePDFText>
              </View>
            </View>
            <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
              <ResumePDFDescription items={descriptions} />
            </View>
          </View>
        </View>
      ))}
    </TemplateThreePDFSectionWithSubsections>
  );
};
